import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage/HomePage';
import RLPage from './pages/CaseStudies/RL/RLPage';
import LLMPage from './pages/CaseStudies/LLM/LLMPage';
import CVPage from './pages/CaseStudies/CV/CVPage';
import AboutPage from "./pages/AboutPage/AboutPage";
import TermPage from "./pages/TermPage/TermPage";
import Contact from "./pages/Contact/Contact";
import './App.css';
import ComputerVisionSolutionPage from "./pages/ComputerVisionSolutionPage/ComputerVisionSolutionPage";
import ScrollToTop from './components/utils/ScrollToTop';
import LLMSolutionPage from './pages/LLMSolutionPage/LLMSolutionPage';
import Submit from './pages/Contact/Submit';
import ConsultationPage from './pages/ConsultantPage/ConsultationPage';
import ChatbotWidget from './components/ChatbotWidget/ChatbotWidget';

function App() {
    return (
        <Router>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/llm-rag-solutions" element={<LLMSolutionPage />} />
                <Route path="/computer-vision-solutions" element={<ComputerVisionSolutionPage />} />
                <Route path="/reinforcementlearning" element={<RLPage />} />
                <Route path="/llm" element={<LLMPage />} />
                <Route path="/cv" element={<CVPage />} />
                <Route path='/about' element={<AboutPage />} />
                <Route path='/term' element={<TermPage />} />
                <Route path='/contact' element={<Contact />} />
                <Route path='/contact/submit' element={<Submit />} />
                <Route path='/consultation' element={<ConsultationPage />} />
            </Routes>
            <ChatbotWidget />
        </Router>
    );
}

export default App;
